import { Component, EventEmitter, Input, OnChanges, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { AllowedOrgUnits, CompositeFilter, FilterCodec, FormatedSavedFilter } from '@teammood/filter';
import { StatsService } from 'app/frontend/lib/analytics/stats/stats.service';
import { FilterDialogService } from 'app/frontend/lib/filter/filter-dialog/filter-dialog.service';
import { takeUntil, tap } from 'rxjs';
import { FilterEditorComponent } from '../../editor/filter-editor.component';


@Component({
    selector: 'saved-filter-manager',
    templateUrl: './saved-filter-manager.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [TranslateModule, FilterEditorComponent]
})
export class SavedFilterManagerComponent implements OnInit, OnChanges{
    
    // protected currentFilter: FormatedSavedFilter;
    orgUnits: AllowedOrgUnits[];

    @Input() filter: FormatedSavedFilter;
    @Input() show: boolean;
    @Input() managerMode: 'create' | 'update' | 'forward' | 'inactive';
    @Input() isFilterUpdated: boolean;
    @Input() managerInDialog: boolean;

    @Output() onCreateOrUpdateFilter = new EventEmitter();
    @Output() filterChange = new EventEmitter();
    @Output() setAsDefault = new EventEmitter<{id: string}>();


    constructor(
        private filterDialogService: FilterDialogService,
        private statsService: StatsService,
        private filterCodec: FilterCodec
    ){}

    async ngOnInit() {
        // this.currentFilter = this.filter;
        this.orgUnits = await this.statsService.all_org_units();
    }

    ngOnChanges() {
        // wathch managerInDialog change
    }

    async displayManager (){
        if(!this.managerInDialog){
            this.show = true;
        }else{
            this.onOpenFilterDialog(this.filter);
        }
    }

    callSetAsDefault(filterId: {id: string}){
        this.setAsDefault.emit(filterId);
    }

    save (filter: FormatedSavedFilter){
        filter.decodedFilter = this.filter.decodedFilter;
        filter.filter = this.filterCodec.encode(this.filter.decodedFilter);
        this.onOpenFilterDialog(filter)
    }

    openModalInDefaultMode (filter: FormatedSavedFilter){
        filter.default = true;
        this.onOpenFilterDialog(filter);
    }

    async onOpenFilterDialog(filter: FormatedSavedFilter) {
        let mode = this.managerMode;
        if(mode === 'inactive') return
        if(mode === 'forward') mode = 'create';
        const dialogRef = await this.filterDialogService.openFilterDialog(filter, mode);

        dialogRef.beforeClosed().pipe(
            tap(data => {
                if (data) this.onCreateOrUpdateFilter.emit(data.filter);
                this.show = false;
            }),
            takeUntil(dialogRef.afterClosed())
        ).subscribe();
    }

    closeManager (){
        this.show = false;
        // this.currentFilter = this.filter;
    }

    onFilterChange (filter: CompositeFilter) {
        this.isFilterUpdated = true;
        this.filter.decodedFilter = filter;
        // this.currentFilter.decodedFilter = filter;
        this.filterChange.emit(filter);
    }
}

